import useUI from 'hooks/use-ui';
import useTranslation from 'hooks/use-translation';

import { WhoopsReason } from './whoops.types';

type UseWhoopsCopyParams = {
  reason: WhoopsReason;
};

type UseWhoopsCopyReturn = {
  topText: string;
  bottomText?: string;
  buttonText: string;
  onButtonClick: () => void;
};

function useWhoopsConfig({ reason }: UseWhoopsCopyParams): UseWhoopsCopyReturn {
  const { t } = useTranslation();

  if (reason === WhoopsReason.pageNotFound) {
    return {
      topText: t('whoops.could-not-find-page', "We're sorry, we couldn't find the page you were looking for!"),
      bottomText: t('whoops.page-does-not-exist', "It looks like the page you requested doesn't exist."),
      buttonText: t('go-back', 'Go Back'),
      onButtonClick: () => window.history.back(),
    };
  }

  return {
    topText: t('whoops.something-went-wrong', "We're sorry, something went wrong."),
    buttonText: t('try-again', 'Try Again'),
    onButtonClick: () => window.location.reload(),
  };
}

type UseWhoopsReturn = UseWhoopsCopyReturn & {
  isDutchieMain: boolean;
  isIframe: boolean;
};

export function useWhoops(reason: WhoopsReason): UseWhoopsReturn {
  const { isDutchieMain, isIframe } = useUI();
  const whoopsConfig = useWhoopsConfig({ reason });

  return {
    isDutchieMain,
    isIframe,
    ...whoopsConfig,
  };
}
